import { json } from "react-router-dom";
import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getpageDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.getAllPageUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get Page api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get Page api err", err);
      throw err;
    }
  };
};

export const getPageWithSlugAPI = (pageSlug, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.pageUrl}?page_slug=${pageSlug}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          throw err;
        });
    } catch (err) {
      throw err;
    }
  };
};

export const addpageDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.pageUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add Page api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add page api err:", err);
      throw err;
    }
  };
};

export const updatePageDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.pageUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update menu api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update menu api err:", err);
      throw err;
    }
  };
};

export const deletePageDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiDelete(`${ApiConstants.pageUrl}/?page_id=${data}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("delete product category api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("delete product category api err:", err);
      throw err;
    }
  };
};
